import { Outlet, useMatch } from 'react-router-dom';
import WorkbookProgressTracker from './WorkbookProgressTracker';
import { Card, CardContent } from '../ui/card';
import TrialStatusBanner from './TrialStatusBanner';
import {
    WIDE_WORKBOOK_STEPS,
    type WorkbookStepKey,
} from './workbookWizardConstants';

export default function WorkbookWizard() {
    const match = useMatch('/wizard/:step');
    const currentStep = (match?.params.step ?? 'business-info') as WorkbookStepKey;

    const isWideStep = WIDE_WORKBOOK_STEPS.has(currentStep);

    return (
        <div className="flex min-h-screen flex-col bg-background lg:flex-row">
            <WorkbookProgressTracker currentStep={currentStep} />

            <div className="flex-1 overflow-y-auto">
                <TrialStatusBanner />
                <div
                    className={`mx-auto px-4 py-8 sm:px-6 lg:px-10 lg:py-12 ${
                        isWideStep ? '' : 'max-w-3xl'
                    }`}
                >
                    <Card className="border-subtle bg-card shadow-none">
                        <CardContent className="p-5 sm:p-8 lg:p-10">
                            <Outlet />
                        </CardContent>
                    </Card>
                </div>
            </div>
        </div>
    );
}
